import { MAP_MAX_ZOOM, MAP_MIN_ZOOM } from '@/constants';
export const getZoomRangesByTransactionType = (transactionType, geoConfig, layerType) => {
    const zoomRangesRulesForTransactionType = [];
    Object.entries(geoConfig).forEach(([key, { map }]) => {
        const mapValueByType = map?.[transactionType];
        const minzoom = mapValueByType?.[layerType]?.minZoom;
        if (minzoom) {
            zoomRangesRulesForTransactionType.push({
                placeType: key,
                minzoom,
            });
        }
    });
    return zoomRangesRulesForTransactionType;
};
export const adjustZoomRanges = (tileLayers, zoomRanges) => {
    // Remove place type layer that does not exist on our rules
    const tileLayersFiltered = tileLayers.filter((tileLayer) => {
        return (zoomRanges.findIndex((zoomRange) => zoomRange?.placeType === tileLayer.place.type) >= 0);
    });
    // Adjust zoom level according to our rules
    tileLayersFiltered.forEach(function (tileLayer, currentIndex) {
        const isLastLayer = tileLayersFiltered.length === currentIndex + 1;
        const tileLayerZoomRange = zoomRanges.find((step) => step?.placeType === tileLayer.place.type);
        let nextRangeMinZoom;
        if (!isLastLayer) {
            const nextRange = zoomRanges.find((step) => step?.placeType === tileLayersFiltered[currentIndex + 1].place.type);
            // store the value for the next layer
            nextRangeMinZoom = nextRange?.minzoom;
        }
        // adjust minzoom and maxzoom depending of the level position
        tileLayer.minzoom = currentIndex === 0 ? MAP_MIN_ZOOM : tileLayerZoomRange.minzoom;
        // adjust maxzoom of the last layer
        tileLayer.maxzoom = nextRangeMinZoom ?? MAP_MAX_ZOOM;
    });
    return tileLayersFiltered;
};
